import React from 'react';
import './btn.css';

const Button = (props) => {
    return ( 
        <>
        <button type={props.btnType} className='btn body'>
            {props.btnText}
        </button>
        </>
     );
}
 
export default Button ;